import { render, staticRenderFns } from "./CommentReactBtn.vue?vue&type=template&id=30605432&scoped=true&"
import script from "./CommentReactBtn.vue?vue&type=script&lang=js&"
export * from "./CommentReactBtn.vue?vue&type=script&lang=js&"
import style0 from "./CommentReactBtn.vue?vue&type=style&index=0&id=30605432&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30605432",
  null
  
)

export default component.exports